export default __webpack_public_path__ + "cd093cd62c9a04bf67323bc60a856e39.jpg";